// Should be called in constructor after super()
export function gatherProperties(propertyList, host) {
    const ownProperties = Object.getOwnPropertyNames(host); // list of property names that have been defined on the instance and not inherited.
    propertyList.forEach(propertyName => {
        const hasPreInitValue = ownProperties.includes(propertyName.toString());
        // if a watched property name has a pre-initialization value.
        if (hasPreInitValue) {
            if (host.preDefinitionProperties === undefined)
                host.preDefinitionProperties = {};
            // then save the value on a cache object and apply it again in the `initGatheredProperties`.
            host.preDefinitionProperties[propertyName] = host[propertyName];
            delete host[propertyName];
        }
    });
}
// Should be called in connectedCallback() (after super() if super exists).
export function initGatheredProperties(host) {
    if (host.preDefinitionProperties) {
        // By this time the setters have been initialized so the component can react according to its preinit properties.
        Object.assign(host, host.preDefinitionProperties);
        // Clean up.
        delete host.preDefinitionProperties;
    }
}
